import './Title.css';

interface TitleProps {
  text: string;
  pos: { left: string; top: string };
}

export const Title = ({ text, pos }: TitleProps) => {
  return (
    <span className="Title" style={pos}>
      {text}
    </span>
  );
};
